import React from 'react';
export default function Card({ children, style = {} }) {
  return <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e6de', padding: 20, ...style }}>{children}</div>;
}
